import { render, staticRenderFns } from "./CozeChat.vue?vue&type=template&id=32fd335e&scoped=true&"
import script from "./CozeChat.vue?vue&type=script&lang=js&"
export * from "./CozeChat.vue?vue&type=script&lang=js&"
import style0 from "./CozeChat.vue?vue&type=style&index=0&id=32fd335e&prod&scoped=true&lang=css&"
import style1 from "./CozeChat.vue?vue&type=style&index=1&id=32fd335e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fd335e",
  null
  
)

export default component.exports